import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {SaleInvoiceModule} from './modules/invoice/saleInvoice.module';
import {PaymentRequestModule} from './modules/payment_request/paymentRequest.module';
import {SaleProductModule} from './modules/product/saleProduct.module';
import {PurchaseOrderModule} from './modules/purchase_order/purchaseOrder.module';
import {errorMessages} from '../core/error/errorMessages';
import {SaleRetrocessionModule} from './modules/retrocession/sale-retrocession.module';
import {SaleDataService} from './impl/service/ngrx/SaleData.service';
import {SaleRepository} from './impl/service/ngrx/Sale.repository';
import {PaymentModule} from "./modules/payment/payment.module";
import {ProductModule} from "../product/product.module";

@NgModule({
    providers: [
    ],
    imports: [
        SaleInvoiceModule,
        PaymentRequestModule,
        SaleProductModule,
        PurchaseOrderModule,
        SaleRetrocessionModule,
        PaymentModule,
        ProductModule,
    ]
})
export class SaleModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: SaleRepository,
                dataService: SaleDataService,
    ) {

        entityDataService.registerServices({
            Sale: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Sale: service,
        });
        errorMessages.set('SALE_DELETE_PRODUCT_WRONG_STATUS',
            'La suppression d\'un produit n\'est pas possible avec ce statut de la vente');
        errorMessages.set('SALE_DELETE_PRODUCT_INVOICE_EXISTS',
            'La suppression d\'un produit n\'est pas possible lorsqu\'une facture a déjà été créée');
        errorMessages.set('SALE_DELETE_PRODUCT_LAST_PRODUCT',
            'La suppresion du dernier produit est interdit');
    }
}
